import React from "react";
import PropTypes from "prop-types";

import styles from "./BylinePhoto.css";

export default function BylinePhoto({ photoSrc }) {
  return (
    <img src={photoSrc} role="presentation" alt="" className={styles.root} />
  );
}

BylinePhoto.propTypes = {
  photoSrc: PropTypes.string.isRequired,
};
